import React from 'react';
import { VimeoButton } from '../../articles/single/article';

const ArticleMobileLinks = ({ props: { videoCode, onPlayVideo, audioUrl } }) => (
  <div className="site-header__links-mobile">
    {videoCode && (
      <VimeoButton
        buttonClassName="site-header__links-mobile-watch"
        buttonText="Watch"
        showIcon={false}
        onPlay={onPlayVideo}
      />
    )}
    {audioUrl && (
      <a href={audioUrl} className="site-header__links-mobile-listen" target={`_blank`}>
        Listen
      </a>
    )}
  </div>
);

export default ArticleMobileLinks;
